// @flow

import { type CardBrand } from '@tectonics/prs/card-brand';
import { type TokenizedCard } from './types';

export function getBrand(tokenized: TokenizedCard): CardBrand {
  return tokenized['brand'];
}
